import { render, staticRenderFns } from "./AddPromocode.vue?vue&type=template&id=02c6882e&"
import script from "./AddPromocode.vue?vue&type=script&lang=js&"
export * from "./AddPromocode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c6882e')) {
      api.createRecord('02c6882e', component.options)
    } else {
      api.reload('02c6882e', component.options)
    }
    module.hot.accept("./AddPromocode.vue?vue&type=template&id=02c6882e&", function () {
      api.rerender('02c6882e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promocodes/AddPromocode.vue"
export default component.exports